const howToTestScreenMessages = {
    testInfoText : "Go ahead and take the test. Wait 15 minutes for the results to be visible. Then, click “Continue” below. See below for instructions on how to take the test.",
    readInstructionsLabel  : "Read step by step instructions",
    videoTutorialLabel : "Watch a video tutorial",
    procedureStepsLabel : 'Sample Test Procedure',
    goBack : 'Go Back',
    resultTitle: 'Result Interpretation'
};

export default howToTestScreenMessages;